export default __webpack_public_path__ + "static/media/Q17_4_resized.a4f35fab.jpg";